export interface ProviderLabel {
  id: number;
  providerId: number;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface Provider {
  id: number;
  // Campos obligatorios
  name: string;
  cif: string;
  email: string;
  // Campos opcionales
  telephone: string | null;
  website: string | null;
  contact: string | null;  // Persona de contacto
  // Dirección (opcionales)
  address: string | null;
  city: string | null;
  postalcode: string | null;
  state: string | null;  // Provincia
  // Otros
  description: string | null;
  idPinecone: string | null;
  labels: ProviderLabel[];
  createdAt: string;
  updatedAt: string | null;
}

export interface ProviderCreate {
  // Campos obligatorios
  name: string;
  cif: string;
  email: string;
  // Campos opcionales
  telephone?: string;
  website?: string;
  contact?: string;
  address?: string;
  city?: string;
  postalcode?: string;
  state?: string;
  description?: string;
  labels?: { name: string; description?: string }[];
}

export interface ProviderUpdate {
  name?: string;
  cif?: string;
  email?: string;
  telephone?: string;
  website?: string;
  contact?: string;
  address?: string;
  city?: string;
  postalcode?: string;
  state?: string;
  description?: string;
}

export interface ProviderListResponse {
  items: Provider[];
  total: number;
  page: number;
  pageSize: number;
}

export type NeedProviderStatus =
  | "Contacto"
  | "Solicitado Presupuesto"
  | "Presupuesto recibido"
  | "Desiste"
  | "Asignado";

export const NEED_PROVIDER_STATUS_COLORS: Record<NeedProviderStatus, string> = {
  Contacto: "bg-gray-100 text-gray-800",
  "Solicitado Presupuesto": "bg-blue-100 text-blue-800",
  "Presupuesto recibido": "bg-purple-100 text-purple-800",
  Desiste: "bg-red-100 text-red-800",
  Asignado: "bg-green-100 text-green-800",
};

export interface NeedProvider {
  id: number;
  needId: number;
  status: NeedProviderStatus;
  amount: number | null;
  desist: boolean;
  assigned: boolean;
  provider: Provider;
  file: import("./file").FileRecord | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface MailNeed {
  id: number;
  needProviderId: number;
  doc: string | null;
  documentName: string | null;
  type: string | null;
  send: boolean;
  active: boolean;
  sentAt: string | null;
  createdAt: string;
}

export interface MailNeedSend {
  documentId?: number;
  customContent?: string;
  type: "request" | "reminder" | "assignment" | "received" | "custom";
}

export interface SendEmailResponse {
  success: boolean;
  message: string;
  mailId: number | null;
}

export interface NeedProviderCreate {
  needId: number;
  providerId: number;
}

export interface NeedProviderUpdate {
  status?: NeedProviderStatus;
  amount?: number;
  desist?: boolean;
  assigned?: boolean;
}

export interface NeedProviderListResponse {
  items: NeedProvider[];
  total: number;
}

export interface MailNeedListResponse {
  items: MailNeed[];
  total: number;
}
